import { render, staticRenderFns } from "./DriverItems.vue?vue&type=template&id=a46072fa&scoped=true"
import script from "./DriverItems.vue?vue&type=script&lang=ts"
export * from "./DriverItems.vue?vue&type=script&lang=ts"
import style0 from "./DriverItems.vue?vue&type=style&index=0&id=a46072fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46072fa",
  null
  
)

export default component.exports